module.exports = __webpack_public_path__ + "static/media/pending.4074d0c3.png";